"use client";

interface MobileMenuToggleProps {
  isOpen: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

export function MobileMenuToggle({
  isOpen,
  onToggle,
  disabled,
}: MobileMenuToggleProps) {
  return (
    <button
      type="button"
      aria-label={isOpen ? "Close menu" : "Open menu"}
      aria-expanded={isOpen}
      onClick={() => {
        if (disabled) return;
        onToggle();
      }}
      className={`mobile-menu-toggle ${isOpen ? "opened" : "closed"} bg-primary`}
    >
      <span className="mobile-menu-bar" data-position="top" />
      <span className="mobile-menu-bar" data-position="bottom" />
    </button>
  );
}
